module.exports = __webpack_public_path__ + "static/media/close.65c70671.png";